var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 10.3084 3.69158 13 7 13C10.3084 13 13 10.3084 13 7C13 3.69158 10.3085 1 7 1C3.69151 1 1 3.69158 1 7ZM7 11.927C4.28324 11.927 2.07303 9.71683 2.07303 7C2.07303 5.83455 2.48063 4.76296 3.15971 3.91841L10.0816 10.8403C9.23704 11.5194 8.16552 11.927 7 11.927ZM11.927 7C11.927 8.16545 11.5194 9.23704 10.8404 10.0816L3.91841 3.15971C4.76296 2.48063 5.83455 2.07303 7 2.07303C9.71676 2.07303 11.927 4.28324 11.927 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.e7ca6d9ec15f0646cc1813de5fd4f844.svg";
export { ForwardRef as ReactComponent };